import Qr from './Qr';

export default Qr;
